"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordModal = void 0;
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const store_1 = require("client/modules/store/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./confirmation-modal.less");
let ChangePasswordModal = class ChangePasswordModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.passwordsMatch = false;
        this.passwordFields = {
            password: "",
            confirmPassword: ""
        };
        this.testpw = "";
        // componentDidMount() {
        // }
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
        this.handleConfirmClick = () => {
            this.props.onConfirm(this.passwordFields.password);
        };
        this.comparePasswords = () => {
            const { password, confirmPassword } = this.passwordFields;
            if (password !== confirmPassword || Number(password.length) < 8) {
                this.passwordsMatch = false;
            }
            else {
                this.passwordsMatch = true;
            }
        };
        // Might implement CLient-side Hashing in the future.
        // private hashPassword = () => {
        // }
        this.handleChangeString = (fieldName) => (event, value) => {
            this.passwordFields[fieldName] = event.currentTarget.value;
            if (this.missing[fieldName] === true) {
                this.missing[fieldName] = false;
            }
            this.comparePasswords();
        };
    }
    componentWillMount() {
        this.missing = {
            password: false,
            confirmPassword: false
        };
        this.comparePasswords();
    }
    renderMessage(content) {
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: content } });
    }
    render() {
        const { currentUser, title, message, editableUserId, userCreation } = this.props;
        const { password, confirmPassword } = this.passwordFields;
        const classAdjust = () => store_1.generalStore.menuOpen ? "modal-body modal-body--fix" : "modal-body";
        mobx_1.observe(store_1.generalStore, change => {
            this.handleCancelClick();
        });
        return (React.createElement("div", { className: "confirmation-modal" },
            React.createElement("div", { className: "modal-background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: classAdjust() },
                React.createElement("div", { className: "modal-title" }, title),
                React.createElement("div", { className: "modal-message" }, this.renderMessage(message)),
                currentUser &&
                    (currentUser.admin ||
                        currentUser.id === editableUserId ||
                        userCreation) && (React.createElement(text_field_1.MaterialTextField, { className: "password", label: "New Password", missing: this.missing.password, onChange: this.handleChangeString("password"), type: "password", value: password, newPasswordField: true })),
                currentUser &&
                    (currentUser.admin ||
                        currentUser.id === editableUserId ||
                        userCreation) && (React.createElement(text_field_1.MaterialTextField, { className: "password", label: "Confirm New Password", missing: this.missing.confirmPassword, onChange: this.handleChangeString("confirmPassword"), type: "password", value: confirmPassword, newPasswordField: true })),
                React.createElement("div", { className: "modal-button-group" },
                    React.createElement(button_1.MaterialButton, { secondary: true, className: "modal-button", onClick: this.props.onCancel }, "Cancel"),
                    React.createElement(button_1.MaterialButton, { primary: true, className: "modal-button ", disabled: !this.passwordsMatch, onClick: this.handleConfirmClick }, "Confirm")))));
    }
};
__decorate([
    mobx_1.observable
], ChangePasswordModal.prototype, "userId", void 0);
__decorate([
    mobx_1.observable
], ChangePasswordModal.prototype, "passwordsMatch", void 0);
__decorate([
    mobx_1.observable
], ChangePasswordModal.prototype, "passwordFields", void 0);
__decorate([
    mobx_1.observable
], ChangePasswordModal.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], ChangePasswordModal.prototype, "testpw", void 0);
ChangePasswordModal = __decorate([
    mobx_react_1.observer
], ChangePasswordModal);
exports.ChangePasswordModal = ChangePasswordModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/change-password-modal/change-password-modal.tsx
// module id = 4071
// module chunks = 0